import '../promote_ui/init.js';
import 'intersection-observer/intersection-observer';
import 'regenerator-runtime/runtime';

import cssVars from 'css-vars-ponyfill';

cssVars({
  watch: true,
});
